/**
 * Implements the image preview link.
 */
class ImagePreviewLink {
  constructor( args ) {
		this.args = args;
		this.render();
	}
	render() {
	};
};

export default ImagePreviewLink;